import { createFileRoute } from '@tanstack/react-router'

import EditPenyuluhProvinsiPage from '@/components/pages/backoffice/_klb-penyuluh/_provinsi/_$provinsiId/edit/containers/EditPenyuluhProvinsiPage'

export const Route = createFileRoute(
  '/_backoffice/klb-penyuluh/provinsi/$provinsiId/edit/'
)({
  component: EditPenyuluhProvinsiPage
})
